const TaskStatus = 
{
    Seen : 1,
    Selected : 2,
    Skipped : 3,
    HasError : 4,
    Incompatible : 5,
    ApproveSeen:6,
    Approve: 7,
    Reject:8,
    NotSure:9
}
;

export default TaskStatus;